import moment from "moment";
import React, { useState } from "react";
import { OverlayTrigger } from "react-bootstrap";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { withTranslation } from "react-i18next";
import { BiPencil } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { LS_AUTHORITY_KEY } from "../../../core/constants/common";
import "./../../Common/Standards/StandardsAdminMain/StandardsAdminMain.scss";
import DisclosureFormPopup from "./DisclosureFormPopup";
import Utils from "../../../core/utilities/Utils";

const DisclosureListItem = ({ t, item, refreshCallback }) => {
  const authorityData = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY)); 
  const navigate = useNavigate();
  const [showDiscFormPopup, setShowDiscFormPopup] = useState(false);

  const openDisclosure = (id) => {
    navigate('/admin/gd_questions/' + id);
  };

  const saveCallback = (refresh) => {
		setShowDiscFormPopup(false);
    if (!refresh) return;
    
    refreshCallback();
	};

  return (
    <>
      <div
        className={`card StandardsAdminMain_listCard 1`}
        id={item?.id}
        key={item?.id}>
        <div className="card-body p-0">
          <div className="SML_Add_Card_row01">
            <div className="row m-0">
              <div className="col-lg-8 p-1">
                <div className="row m-0 SML_Add_Card_head">
                  <div className="col-lg-6 p-0">
                    <ul>
                      <li>
                        <h6 className="mb-0 me-2 cursor" onClick={() => openDisclosure(item?.id)} >{item?.name}</h6>
                      </li>                      
                    </ul>
                  </div>
                  <div className="col-lg-6 p-0">
                    <ul>
                      <li>
                        {t("LastModified.label")}{" "}
                        <h6 className="mb-0 ms-2">
                          {moment(item?.lastModifiedDate).format(
                            "MMM DD, YYYY"
                          )}
                        </h6>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 p-1 text-end">
                <div className="row m-0 ">
                  {authorityData?.roles?.includes("SUPER_ADMIN") && (
                    <div className="col-lg-4 p-0 text-end">
                      <OverlayTrigger
                        placement="top"
                        overlay={Utils.renderTooltip(
                          t("EditUniversalStandard.label")
                        )}>
                        <button
                          className="btn btn-blank_outline"
                          onClick={() => setShowDiscFormPopup(true)}>
                          <BiPencil />
                        </button>
                      </OverlayTrigger>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showDiscFormPopup && 
        <DisclosureFormPopup 
          disclosureId={item.id}
          disclosureName={item.name}
          discStandardType={item.standardType}
          saveCallback={saveCallback} />
      }
    </>
  );
};
export default withTranslation()(DisclosureListItem);
